module.exports = __webpack_public_path__ + "static/media/BRC_1650578_pdf.f6256bdb.pdf";